export const TIER_META = {
  full: { label: "Full", cls: "bg-emerald-100 text-emerald-800", dot: "bg-emerald-500" },
  partial: { label: "Partial", cls: "bg-amber-100 text-amber-800", dot: "bg-amber-400" },
  small: { label: "Small step", cls: "bg-sky-100 text-sky-800", dot: "bg-sky-400" },
  showed_up: { label: "Noticed", cls: "bg-stone-100 text-stone-700", dot: "bg-stone-300" },
};
export const TIER_ORDER = ["full", "partial", "small", "showed_up"];
export const PERIODS = [
  { v: "morning", label: "Morning" }, { v: "afternoon", label: "Afternoon" }, { v: "evening", label: "Evening" }, { v: "night", label: "Night" },
];
export const RUBRIC_TYPES = [
  { v: "yesno", label: "Done / not done", hint: "One tap. Nothing to measure." },
  { v: "time_by", label: "By a time", hint: "e.g. out of bed by 7:00 — earlier is Full, within the hour is Partial." },
  { v: "time_of_day", label: "Part of the day", hint: "e.g. morning workout — any other time still counts." },
  { v: "quantity", label: "An amount", hint: "e.g. 20 pages, 8 glasses — half of it is Partial." },
  { v: "duration", label: "Minutes", hint: "e.g. 10 minutes of meditation." },
  { v: "limit", label: "Keep it under", hint: "For easing off — none is Full, a little is Partial." },
  { v: "self", label: "Self-rated", hint: "Write what each tier means; you pick the one that fits at check-in." },
];
export const DEFAULT_RUBRIC = { type: "yesno", unit: "", counts_from: "showed_up", tiers: [{ key: "full", label: "Done", rule: {}, weight: 1 }] };
const PERIOD_HOURS = { morning: [5, 12], afternoon: [12, 17], evening: [17, 22], night: [22, 29] };

export function periodOf(value) {
  if (PERIOD_HOURS[value]) return value;
  if (typeof value === "string" && /^\d\d:\d\d$/.test(value)) {
    let h = parseInt(value.slice(0, 2), 10);
    if (h < 5) h += 24;
    return Object.keys(PERIOD_HOURS).find((p) => h >= PERIOD_HOURS[p][0] && h < PERIOD_HOURS[p][1]) || "night";
  }
  return null;
}

function matches(type, rule, value) {
  if (type === "time_by") return typeof value === "string" && /^\d\d:\d\d$/.test(value) && value <= (rule.max_time ?? "99:99");
  if (type === "time_of_day") return (rule.periods || []).includes(periodOf(value));
  if (type === "quantity" || type === "duration") return typeof value === "number" && value >= (rule.min ?? 0);
  if (type === "limit") return typeof value === "number" && value <= (rule.max ?? 0);
  return false;
}

export function gradeValue(rubric, value) {
  if (!rubric || rubric.type === "yesno") return rubric?.tiers?.[0] || DEFAULT_RUBRIC.tiers[0];
  if (rubric.type === "self") return rubric.tiers.find((t) => t.key === value) || rubric.tiers[rubric.tiers.length - 1];
  for (const t of rubric.tiers) {
    if (!t.rule || Object.keys(t.rule).length === 0) return t;
    if (matches(rubric.type, t.rule, value)) return t;
  }
  return rubric.tiers[rubric.tiers.length - 1];
}

export function ruleText(type, rule, unit) {
  if (type === "self") return rule?.text || "you decide";
  if (!rule || Object.keys(rule).length === 0) return "anything else";
  if (type === "time_by") return `by ${rule.max_time}`;
  if (type === "time_of_day") return (rule.periods || []).join(" / ");
  if (type === "quantity" || type === "duration") return `${rule.min}+ ${unit || ""}`.trim();
  if (type === "limit") return rule.max === 0 ? "none" : `${rule.max} or fewer`;
  return "";
}

export function needsValue(rubric) {
  return rubric && rubric.type !== "yesno" && rubric.type !== "self";
}

export function isNumeric(type) {
  return ["quantity", "duration", "limit"].includes(type);
}
